import { Box, Typography, IconButton } from "@mui/material";

import Search from "../common/search.jsx";

import RefreshIcon from "@mui/icons-material/Refresh";

/** Presentational section; state and actions remain owned by its parent. */
export default function TableToolbar({ title, length, setSearch, search, setApplySearch, setRefresh, setSelected, pageType, limit, setLimit, selected, busy = false }) {
  return (
<Box className="relative grid md:grid-cols-2 gap-y-4 md:px-3">
            <div className="flex items-center md:justify-start justify-between">
              <div className="flex items-center gap-2">
                <Typography
                  sx={{ fontSize: { md: "1rem !important", xs: "0.8rem" } }}
                  variant="h6"
                >
                  {title}
                </Typography>
                <Typography
                  sx={{
                    borderLeft: "1px solid #dbdfea",
                    fontSize: { md: "0.83rem !important" },
                    color: (theme) =>
                      theme.palette.mode === "light" ? "#001ee4" : "#90caf9",
                  }}
                  className="px-2 mx-2"
                  variant="body2"
                >
                  {length == null ? "تعداد نتایج: نامشخص" : `تعداد نتایج : ${length} مورد`}
                </Typography>
                <div className="hidden mx-5 md:flex justify-center">
                  {" "}
                  <div className="md:w-[350px] md:mb-0 mb-4 w-full ">
                    <Search
                      setSearch={setSearch}
                      search={search}
                      setApplySearch={setApplySearch}
                    />
                  </div>
                </div>
              </div>{" "}
              <div className="flex md:hidden  justify-end">
                <IconButton
                  aria-label="تازه‌سازی جدول" disabled={busy}
                  sx={{
                    background: "#f0f0f0 !important",
                    width: "1.3rem !important",
                    padding: "2px !important",
                    height: "1.3rem !important",
                    fontSize: "1.5rem !important",
                  }}
                  onClick={() => {
                    setSearch("");
                    setApplySearch("");
                    setRefresh((r) => r + 1);
                    setSelected([]);
                  }}
                >
                  <RefreshIcon sx={{ color: "#001ee4" }} />
                </IconButton>
              </div>
            </div>

            <div className="flex md:hidden justify-center">
              {" "}
              <div className="md:w-[350px] md:mb-0 mb-4 w-full ">
                <Search
                  setSearch={setSearch}
                  search={search}
                  setApplySearch={setApplySearch}
                />
              </div>
            </div>
            <div className="hidden md:flex items-center justify-end gap-2 ">
              {pageType === 2 && (
                <div className="flex gap-2 border rounded-md p-2 items-center mx-7">
                  <span className="text-xs">تعداد سطر :‌</span>
                  <Box
                    component={"select"}
                    value={limit}
                    onChange={(e) => setLimit(e.target.value)}
                    sx={{
                      background: (theme) => theme.palette.background.paper,
                    }}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                  </Box>
                </div>
              )}

              <IconButton
                aria-label="تازه‌سازی جدول" disabled={busy}
                sx={{
                  background: "#f0f0f0 !important",
                  width: "1.3rem !important",
                  padding: "2px !important",
                  height: "1.3rem !important",
                  fontSize: "1.5rem !important",
                }}
                onClick={() => {
                  setSelected([]);
                  setSearch("");
                  setApplySearch("");
                  setRefresh((r) => r + 1);
                }}
              >
                <RefreshIcon sx={{ color: "#001ee4" }} />
              </IconButton>
            </div>
            {selected?.length > 0 && (
              <div className="absolute -bottom-2 right-2 text-[0.7rem] text-[#001ee4]">
                {selected?.length} مورد انتخاب شده
              </div>
            )}
          </Box>
  );
}
